import React from 'react';
import PropTypes from 'prop-types';
import EventCard from './EventCard';

const EventList = ({ eventMatchData, handleOverlay, handleNavigateHistoryPage, reLoadData, sortedEvents, isMouseOverInput, showDateHeaders, setShowWindow, setSelectId }) => {
  // Show date-grouped list when in search mode OR when showing all events (no date filter)
  const useGroupedView = isMouseOverInput || showDateHeaders;

  return (
    <div className="pt-1 md:pt-6 flex flex-col gap-3">
      {useGroupedView ? (
        sortedEvents.map(([date, matches], index) => {
          const dateObj = new Date(date);
          const today = new Date();
          const isToday = dateObj.toDateString() === today.toDateString();
          const tomorrow = new Date(today);
          tomorrow.setDate(tomorrow.getDate() + 1);
          const isTomorrow = dateObj.toDateString() === tomorrow.toDateString();

          let dateLabel = dateObj.toLocaleDateString('en-US', {
            weekday: 'long',
            month: 'short',
            day: 'numeric',
            year: 'numeric',
          });
          if (isToday) dateLabel = `Today — ${dateLabel}`;
          else if (isTomorrow) dateLabel = `Tomorrow — ${dateLabel}`;

          return (
            <div key={index}>
              <div className={`py-4 pl-2 flex items-center gap-3 ${index > 0 ? 'border-t border-[#E8E8E8] mt-3' : ''}`}>
                <h2 className={`text-left font-bebas text-2xl md:text-3xl ${isToday ? 'text-[#A57C52]' : 'text-[#1A1A1A]'}`}>
                  {dateLabel}
                </h2>
                <span className="bg-[#4A4A4A] text-white text-xs font-montserrat font-medium rounded px-2 py-0.5">
                  {matches.length}
                </span>
              </div>
              <div className='flex flex-col gap-3'>
                {matches.map((match, i) => (
                  <EventCard
                    key={i}
                    match={match}
                    handleOverlay={handleOverlay}
                    handleNavigateHistoryPage={handleNavigateHistoryPage}
                    reLoadData={reLoadData}
                    setShowWindow={setShowWindow}
                    setSelectId={setSelectId}
                  />
                ))}
              </div>
            </div>
          );
        })
      ) : (
        eventMatchData.map((match, i) => (
          <EventCard
            key={i}
            match={match}
            handleOverlay={handleOverlay}
            handleNavigateHistoryPage={handleNavigateHistoryPage}
            reLoadData={reLoadData}
            setShowWindow={setShowWindow}
            setSelectId={setSelectId}
          />
        ))
      )}
    </div>
  );
};

EventList.propTypes = {
  eventMatchData: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleOverlay: PropTypes.func.isRequired,
  handleNavigateHistoryPage: PropTypes.func.isRequired,
  reLoadData: PropTypes.bool.isRequired,
  sortedEvents: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.object)
      ])
    )
  ).isRequired,
  isMouseOverInput: PropTypes.bool.isRequired,
  showDateHeaders: PropTypes.bool,
  setShowWindow: PropTypes.func,
  setSelectId: PropTypes.func,
};

export default EventList;
